import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthorizedDomains from '../common/inputs/customs/authorized-domains';
import TitleAndDescription from '../common/title-and-description';
import Checkbox from '../common/inputs/checkbox-light';
import { FACEBOOK, GOOGLE, MICROSOFT, TWITTER } from '../../models/connect-types';
import DomainItem from './domain-item';
import GoogleAnalytics from './google-analytics';
import { withEditSpot } from '../../../spots/hoc/withEditSpot';

class Advanced extends Component {
  constructor(props, context) {
    super(props, context);
    const connectTypes = props.spot.connectTypes || [];

    this.state = {
      isFacebook: connectTypes.indexOf(FACEBOOK) > -1,
      isTwitter: connectTypes.indexOf(TWITTER) > -1,
      isGoogle: connectTypes.indexOf(GOOGLE) > -1,
      isMicrosoft: connectTypes.indexOf(MICROSOFT) > -1
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.spot !== nextProps.spot) {
      var connectTypes = nextProps.spot.connectTypes || [];

      this.setState({
        isFacebook: connectTypes.indexOf(FACEBOOK) > -1,
        isTwitter: connectTypes.indexOf(TWITTER) > -1,
        isGoogle: connectTypes.indexOf(GOOGLE) > -1,
        isMicrosoft: connectTypes.indexOf(MICROSOFT) > -1
      });
    }
  }

  editConnectType(type, value) {
    this.props.editSpot(this.props.spot.id, { [type]: value });
  }

  onGoogleChange() {
    const isGoogle = !this.state.isGoogle;
    this.editConnectType('google_disabled', this.state.isGoogle);
    this.setState({ isGoogle });
  }

  onFacebookChange() {
    const isFacebook = !this.state.isFacebook;
    this.editConnectType('facebook_disabled', this.state.isFacebook);
    this.setState({ isFacebook });
  }

  onTwitterChange() {
    const isTwitter = !this.state.isTwitter;
    this.editConnectType('twitter_disabled', this.state.isTwitter);
    this.setState({ isTwitter });
  }

  onMicrosoftChange() {
    const isMicrosoft = !this.state.isMicrosoft;
    this.editConnectType('microsoft_disabled', this.state.isMicrosoft);
    this.setState({ isMicrosoft });
  }

  render() {
    const { spot } = this.props;
    const { isFacebook, isTwitter, isGoogle, isMicrosoft } = this.state;

    const domains = spot.authorizedDomains || [];
    let className = 'domains-list';

    if (domains && domains.length > 6) {
      className += ' scrollable';
    }

    return (
      <div className="preferences-premissions">
        <AuthorizedDomains spotId={spot.id} />
        {domains.length ? (
          <div className={className}>
            {domains.map((domain, index) => (
              <DomainItem key={index} domain={domain} />
            ))}
          </div>
        ) : null}
        <div className="login-options">
          <TitleAndDescription
            title="Social Log In Options"
            description="Select which social log in options will be available for your users."
          />
          <Checkbox
            value={isFacebook}
            text="Facebook"
            onChange={this.onFacebookChange.bind(this)}
          />
          <Checkbox value={isTwitter} text="Twitter" onChange={this.onTwitterChange.bind(this)} />
          <Checkbox value={isGoogle} text="Google" onChange={this.onGoogleChange.bind(this)} />
          <Checkbox
            value={isMicrosoft}
            text="Microsoft"
            onChange={this.onMicrosoftChange.bind(this)}
          />
          <>
            <GoogleAnalytics />
          </>
        </div>
      </div>
    );
  }
}

Advanced.displayName = 'Advanced';

Advanced.propTypes = {
  spot: PropTypes.object
};

export default withEditSpot(Advanced);
